import axios from "axios";
import apiClient from "@/utils/ApiClient";


export const ErrorHandling = (error:unknown) => {
    let response = {"status":404, "data":{}};
    if(axios.isAxiosError(error)){
        // response meaning bad request or handling issue
        if (error.response){
            response = {"status":error.response.status, "data":{}}
        }
        // no response meaning network or server issue
        else if (error.request){
            response = {"status":-1, "data":{}}
        }
        // unexpected error in creating a request
        else {
            response = {"status":-2, "data":{}}
        }
    }
    else {
        response = {"status":-3, "data":{}}
    }
    return response
}

export const TokenRefresh = async () => {
    let response = {"status":404, "data":{}};

    if(localStorage.getItem("refreshToken")){
        try {
            // has a weird redirect issue where it tries to post to the frontend if not specified
            const apiResponse = await axios.post("https://api.mediaharbor.app/api/auth/refresh/", {
                refresh: localStorage.getItem("refreshToken"),
            })


            const accessToken = apiResponse.data.access;
            const refreshToken = apiResponse.data.refresh;

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            response = {"status":200, "data":{access:accessToken, refresh:refreshToken}}

            // if on landing refresh after token refresh
            const locationSplit = window.location.href.split("/");

            console.log("location: " + !locationSplit[locationSplit.length - 1]);

            window.location.reload();

            }
        catch(error:any){
            throw error;
            
        }
        return response;
}}

export async function FetchUsername(){
    let response = {"status":404, "data":{}};

    if(localStorage.getItem("accessToken")){
        try {
            const apiResponse = await apiClient.get("/auth/me/");
            response = {"status":200, "data":{username:apiResponse.data.username}};
                
        } catch (error) {  
            response = ErrorHandling(FetchUsername);
        }
    }
    else{
        // token not found
        response = {"status":401, "data":{}}
    }
    return(response)
}

// account registration
export async function AuthRegister(email:string, username:string, password:string) {
    try {
        const apiResponse = await apiClient.post(`/auth/register/`, {
            username: username, password: password, email: email
        });
        return apiResponse.data;
    } catch (error) {
        throw error;
    }
}

// login attempts
export async function AuthLogin(username:string, password:string) {
    try {
        const apiResponse = await apiClient.post(`/auth/login/`, {
            username: username, password: password
        });
        return apiResponse.data;
    } catch (error) {
        throw error;
    }
}

// verify token is still valid
export async function AuthVerify(token:string) {
    try {
        const apiResponse = await apiClient.post(`/auth/verify/`,{token: token})
        return apiResponse.data;
    } catch (error) {
        throw error;
    }
}

// simplified for tanstack use
export async function FetchMe(){
    try {
        const apiResponse = await apiClient.get(`/auth/me/`);
        return apiResponse.data;
    } catch (error) {
        throw error;
    }
}

// public endpoint, does not require authentication
export async function FetchProfile(user:string){
    if(!user){
        throw new Error("Username cannot be empty");
    }
    try {
        const apiResponse = await apiClient.get(`/auth/profile/${user}/`);
        return apiResponse.data;
    } catch (error) {
        throw error;
    }

}

export async function PatchProfile(data:object | FormData){

    let response = {"status":404, "data":{}};

    if(localStorage.getItem("accessToken")){
        try {
            const apiResponse = await apiClient.patch(`/auth/me/`, data)
            response = {"status":200, "data":apiResponse.data}
         
        } catch (error) {
            response = ErrorHandling(error);
        }
    }
    else{
        // token not found
        response = {"status":401, "data":{}}
    }
    return(response);
}

export async function FetchUserLists(user:string){
    if(!user){
        throw new Error("Username is required");
    }

    try {
        const apiResponse = await apiClient.get(`/lists/all/${user}/`)
        return apiResponse.data
    } 
    catch (error) {
        throw error;
    }
}

export async function FetchList(ID:string){
    if(!ID){
        throw new Error("ID is required");
    }

    try {
        const apiResponse = await apiClient.get(`/lists/${ID}/`)
        return apiResponse.data
    } 
    catch (error) {
        throw error;
    }
}

export async function PatchList(ID:string, data:object | FormData){
    if(!ID){
        throw new Error("ID is required");
    }
    if(!data){
        throw new Error("data is required");
    }

    try {
        const apiResponse = await apiClient.patch(`/lists/${ID}/`, data)
        return apiResponse.data
    } 
    catch (error) {
        throw error;
    }
}

export async function DeleteList(ID:string){
    if(!ID){
        throw new Error("ID is required");
    }

    try {
        const apiResponse = await apiClient.delete(`/lists/${ID}/`)
        return apiResponse.data
    } 
    catch (error) {
        throw error;
    }
}

export async function ExternalItemDetails(ID:string,itemType: "movies" | "shows" | "artists" | "albums" | "songs") {
    if (!ID) {
        throw new Error("ID is required");
    }
    if (!itemType) {
        throw new Error("itemType is required");
    }
    
    try {
        const apiResponse = await apiClient.get(`/details/${itemType}/${ID}/`);
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

export async function SearchTMDB(query:string,itemType: "movies" | "shows") {
    if (!itemType) {
        throw new Error("itemType is required");
    }

    try {
        const apiResponse =  await apiClient.get("/tmdb/search" ,{
                    params: {
                        query: query,
                        list_type: itemType
                    }
                })
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

export async function SearchSpotify(query:string,itemType: "albums" | "songs" | "artists") {
    if (!itemType) {
        throw new Error("itemType is required");
    }

    try {
        const apiResponse =  await apiClient.get("/spotify/search" ,{
                    params: {
                        query: query,
                        list_type: itemType
                    }
                })
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

export async function SearchUsers(username:string) {
    if (!username) {
        throw new Error("username is required");
    }

    try {
        const apiResponse =  await apiClient.get(`/user/search/${username}/`)
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

const defaultEmptyPage = {
    count: 0,
    next: null,
    previous: null,
    results: [],
};

export async function GetConsumed(username:string,  page = 1) {
    if (!username) {
        throw new Error("username is required");
    }

    try {
        const apiResponse =  await apiClient.get(`/lists/consumelater/${username}/consumed/`, {
            params: { page: page }
        });
        return apiResponse.data || defaultEmptyPage;
    } 
    catch (error) {
        throw error;
    }
}

export async function GetNotConsumed(username:string, page = 1) {
    if (!username) {
        throw new Error("username is required");
    }

    try {
        const apiResponse =  await apiClient.get(`/lists/consumelater/${username}/not-consumed/`, {
            params: { page: page }
        });
        return apiResponse.data || defaultEmptyPage;
    } 
    catch (error) {
        throw error;
    }
}

interface ConsumeDataType {

    external_id:string;
    item_type:"shows"|"movies"|"songs"|"artists"|"albums";
    title:string;
    year?:string; // not required but highly reccommended for richer data expression
    image_url:string;
    artist?:string; // should exist if its a music type
    status:boolean;
}

export async function PostConsumeLater(username:string, data:ConsumeDataType) {
   
    if(!data.external_id || !data.image_url || !data.item_type || !data.title){
        throw new Error("required field is missing in data");
    }

    try { // user needs access token to use route
        const apiResponse =  await apiClient.post(`/lists/auth-consumelater/`, data);
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

export async function PatchConsumeLater( data:ConsumeDataType[]) {
    if (!data || data.length === 0) {
        throw new Error("No data provided");
    }

    try { // user needs access token to use route
        const apiResponse =  await apiClient.patch(`/lists/auth-consumelater/bulk-update/`, data);
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}

export async function DeleteConsumeLater( data:ConsumeDataType[]) {
    if (!data || data.length === 0) {
        throw new Error("No data provided");
    }

    try { // user needs access token to use route
        const apiResponse =  await apiClient.delete(`/lists/auth-consumelater/bulk-update/`, {data:data});
        return apiResponse.data;
    } 
    catch (error) {
        throw error;
    }
}


